import { Directive, OnInit, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[activeInactivePopup]'
})
export class ActiveInactivePopupDirective implements OnInit {

    constructor(public viewContainerRef: ViewContainerRef) {

    }
    ngOnInit(): void {

    }

}